// Numeros telefonicos (Colombia primero). La clave de busqueda son los ultimos 10 digitos,
// igual que en la app de Twenty (src/lib/telefono.ts), para que CRM y 3CX coincidan.

export const digits = (valor: string | null | undefined) => String(valor ?? '').replace(/\D/g, '');

export const searchKey = (valor: string | null | undefined) => digits(valor).slice(-10);

export const isExtension = (valor: string | null | undefined) => {
  const d = digits(valor);
  return d.length > 0 && d.length <= 5;
};

// Lo que se marca por SIP: digitos, +, * y #.
export const dialable = (valor: string | null | undefined) => String(valor ?? '').replace(/[^0-9+*#]/g, '');

export function looksLikeNumber(texto: string) {
  const t = texto.trim();
  return /^[\d\s+()*#-]+$/.test(t) && digits(t).length >= 3;
}

// "+573104821937" -> "+57 310 482 1937"; "3104821937" -> "310 482 1937"; "104" -> "Ext 104"
export function formatPhone(valor: string | null | undefined, codigo?: string | null) {
  const d = digits(valor);
  if (!d) return '';
  if (d.length <= 5) return `Ext ${d}`;
  const local = d.length > 10 ? d.slice(-10) : d;
  const pais = d.length > 10 ? `+${d.slice(0, d.length - 10)} ` : codigo ? `${codigo} ` : '';
  if (local.length === 10) return `${pais}${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
  if (local.length === 7) return `${pais}${local.slice(0, 3)} ${local.slice(3)}`;
  return `${pais}${local}`;
}

export type Phones = {
  primaryPhoneNumber?: string | null;
  primaryPhoneCallingCode?: string | null;
  primaryPhoneCountryCode?: string | null;
  additionalPhones?: { number?: string; callingCode?: string }[] | null;
};

// Numero completo para marcar desde el campo PHONES de Twenty.
export function phoneFromField(p: Phones | null | undefined) {
  if (!p?.primaryPhoneNumber) return '';
  const code = digits(p.primaryPhoneCallingCode);
  const num = digits(p.primaryPhoneNumber);
  if (!code || num.startsWith(code)) return num;
  return `+${code}${num}`;
}

// Para guardar un telefono escrito por el usuario en el campo PHONES de Twenty.
export function phoneToField(texto: string): Phones {
  const d = digits(texto);
  if (!d) return { primaryPhoneNumber: '', primaryPhoneCallingCode: '', primaryPhoneCountryCode: '' };
  if (texto.trim().startsWith('+') && d.length > 10) {
    const code = d.slice(0, d.length - 10);
    return {
      primaryPhoneNumber: d.slice(-10),
      primaryPhoneCallingCode: `+${code}`,
      primaryPhoneCountryCode: code === '57' ? 'CO' : '',
    };
  }
  if (d.length === 12 && d.startsWith('57')) {
    return { primaryPhoneNumber: d.slice(2), primaryPhoneCallingCode: '+57', primaryPhoneCountryCode: 'CO' };
  }
  return { primaryPhoneNumber: d, primaryPhoneCallingCode: '+57', primaryPhoneCountryCode: 'CO' };
}

export const sameNumber = (a: string | null | undefined, b: string | null | undefined) => {
  const ka = searchKey(a);
  return ka.length >= 7 && ka === searchKey(b);
};

// Letras del teclado telefonico, para buscar por nombre desde el marcador (2=ABC...).
export const KEYPAD: [string, string][] = [
  ['1', ''], ['2', 'ABC'], ['3', 'DEF'], ['4', 'GHI'], ['5', 'JKL'], ['6', 'MNO'],
  ['7', 'PQRS'], ['8', 'TUV'], ['9', 'WXYZ'], ['*', ''], ['0', '+'], ['#', ''],
];
